

export const Payments = (props) => {


    return (
        <div className="form-group mb-5">
            <label className="form-label fs-6 fw-bold">Спосіб оплати</label><br/>
            {props.children}
        </div>
    )
}